import { useEffect } from "react"
import { AxiosError } from "axios"
import { axios } from "../axios"

const methods = ["POST", "PUT", "DELETE", "GET"]

const useErrorHandler = (handleError: () => void) => {
  useEffect(() => {
    if (!axios) {
      // eslint-disable-next-line no-console
      console.error("Axios instance not provided!")
      return
    }

    const errInterceptor = (error: AxiosError) => {
      // eslint-disable-next-line no-console
      console.log(error)
      const method = error.config?.method?.toUpperCase() || ""

      if (error.response?.status === 500) {
        if (methods.includes(method)) {
          handleError()
        }
      }
      return Promise.reject(error)
    }

    axios.interceptors.response.use(undefined, errInterceptor)
  }, [])
}

export default useErrorHandler
